import React from 'react';
import MembersList from './MembersList';
import { ToastContainer } from 'react-toastify';

// Renders the main Team page with a header and MembersList component
const Team: React.FC = () => {
  return (
    <div className='p-2'>
      <h2 className='text-2xl font-bold mb-2'>Team</h2>
      <p className='text-gray-500 mb-6'>Manage team members and their access</p>
      <MembersList />
      <ToastContainer position='top-right' autoClose={3000} />
    </div>
  );
};

export default Team;
